import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { AUTH_OUTPUT } from './topics';

export const CLAIMS_UPDATED = 'AUTH/CLAIMS_UPDATED';

export interface IClaimsUpdatedPayload {
  uid: string;
}

export const claimsUpdatedPayloadSchema = objectSchemaOf<IClaimsUpdatedPayload>(
  {
    uid: Joi.string().required(),
  }
);

export interface IClaimsUpdatedAction {
  type: typeof CLAIMS_UPDATED;
  payload: IClaimsUpdatedPayload;
}

export const claimsUpdatedActionSchema = objectSchemaOf<IClaimsUpdatedAction>({
  type: Joi.string().required().valid(CLAIMS_UPDATED),
  payload: claimsUpdatedPayloadSchema.required(),
});

export const claimsUpdated = actionCreator({
  type: CLAIMS_UPDATED,
  topic: AUTH_OUTPUT,
  schema: claimsUpdatedActionSchema,
});
